import { rootStore } from 'cv-react-core';

const getTheme = () => {
    const { themeStore } = rootStore;
    const theme = themeStore.getSanitizedTheme();

    // Populate the component parts with theme styles
    return {
        chartTextStyle: {
            ...theme.fonts.default,
        },

        container: {
        },

        legendTextStyle: {
            ...theme.fonts.default,
        },

        titleTextStyle: {
            ...theme.fonts.default,
        },

        tooltipTextStyle: {
            ...theme.fonts.default,
            color: '#fff',
        },

        xAxisTextStyle: {
            ...theme.fonts.default,
        },

        yAxisTextStyle: {
            ...theme.fonts.default,
        },
    };
};

export default getTheme;
